import type { AiChatCitationView } from '@/features/ai'

type AiChatCitationListProps = {
  citations: AiChatCitationView[]
}

export function AiChatCitationList({ citations }: AiChatCitationListProps) {
  if (citations.length === 0) {
    return null
  }

  return (
    <ul className="flex flex-wrap gap-2">
      {citations.map((citation, index) => (
        <li key={`${citation.sourceKind}-${citation.sourceRecordId ?? index}`}>
          {citation.openHref ? (
            <a
              className="inline-flex rounded-full bg-white/80 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-primary"
              href={citation.openHref}
            >
              {citation.sourceName}
            </a>
          ) : (
            <span className="inline-flex rounded-full bg-white/80 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-foreground">
              {citation.sourceName}
            </span>
          )}
        </li>
      ))}
    </ul>
  )
}

